import Stack from "@mui/material/Stack";

import EmptyState from "@/components/Core/EmptyState";
import { SkyLoading } from "@/components/Core/Loading";
import { Notification } from "@/types";

import NotificationList from "../List";

interface NotificationMenuBodyProps {
  isLoading: boolean;
  notifications: Notification[];
  onNotificationClick: () => void;
  onMarkRead: (id: string) => void;
}

export const NotificationMenuBody = ({
  isLoading,
  notifications,
  onNotificationClick,
  onMarkRead,
}: NotificationMenuBodyProps) => {
  if (isLoading) {
    return (
      <Stack justifyContent="center" alignItems="center" py={3}>
        <SkyLoading />
      </Stack>
    );
  }

  if (notifications.length === 0) {
    return (
      <EmptyState
        title="notification.empty"
        description="notification.empty-hint"
        minHeight="15rem"
      />
    );
  }

  return (
    <>
      {notifications.map((item) => (
        <NotificationList
          key={item._id}
          notification={item}
          stackProps={{
            onClick: onNotificationClick,
            sx: { cursor: "pointer" },
          }}
          onMarkRead={onMarkRead}
        />
      ))}
    </>
  );
};
